import style from "./Footer.module.css";
import logo from "../assets/logo.png";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faLocationDot, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp, faYoutube, faFacebook, faTiktok, faInstagram } from '@fortawesome/free-brands-svg-icons';

function Footer() {
    const currentYear = new Date().getFullYear();

    const iconStyles = {
        whatsapp: "#33db4f",
        youtube: "#ff0000",
        facebook: "#0065b3",
        tiktok: "#ffffff",
        instagram: "#E1306C",
        phone: "#00d1ae",
        location: "#74bff6",
        email: "#ff9f43"
    };

    const contactDetails = [
        { icon: faPhone, label: "Teléfono", value: "+51 243 4129", color: iconStyles.phone },
        { icon: faWhatsapp, label: "Whatsapp", value: "+51 958 533 331", color: iconStyles.whatsapp, isLink: true, href: "https://wa.me/51958533331" },
        { icon: faEnvelope, label: "Correo", value: "info@dentisanclinicadental.com.pe", color: iconStyles.email, isEmail: true },
        { icon: faLocationDot, label: "Ubicación", value: "Calle Schell 319 Oficina 903", color: iconStyles.location }
    ];

    const socialLinks = [
        { href: "https://www.youtube.com", icon: faYoutube, label: "YouTube", color: iconStyles.youtube },
        { href: "https://www.facebook.com", icon: faFacebook, label: "Facebook", color: iconStyles.facebook },
        { href: "https://www.tiktok.com", icon: faTiktok, label: "TikTok", color: iconStyles.tiktok },
        { href: "https://www.instagram.com", icon: faInstagram, label: "Instagram", color: iconStyles.instagram }
    ];

    return (
        <footer className={style.footer}>
            <div className={style.footerRow}>
                <div className={style.footerItem}>
                    <img src={logo} alt="Logo de la empresa" className={style.logo} />
                    <p className={style.footerText}>
                        En Dentisan, tu salud bucal es lo más importante. Somos una clínica moderna que ofrece atención integral con tecnología avanzada y un equipo comprometido. Brindamos una experiencia segura y profesional, con soluciones para todo tipo de tratamientos dentales.
                    </p>
                </div>

                <div className={style.footerItem}>
                    <h2>Contáctanos</h2>
                    {contactDetails.map(({ icon, label, value, color, isEmail, isLink, href }) => (
                        <p key={label} className={style.contactItem}>
                            <FontAwesomeIcon icon={icon} style={{ color }} className={style.contactIcon} />
                            {label}:{" "}
                            {isEmail ? (
                                <a href={`mailto:${value}`} className={style.emailLink}>{value}</a>
                            ) : isLink ? (
                                <a href={href} target="_blank" rel="noopener noreferrer" className={style.link}>{value}</a>
                            ) : (
                                value
                            )}
                        </p>
                    ))}
                </div>

                <div className={style.footerItem}>
                    <h2>Síguenos</h2>
                    <div className={style.socialIcons}>
                        {socialLinks.map(({ href, icon, label, color }) => (
                            <a key={label} href={href} aria-label={label} className={style.socialLink} style={{ color }} target="_blank" rel="noopener noreferrer">
                                <FontAwesomeIcon icon={icon} size="lg" />
                            </a>
                        ))}
                    </div>
                </div>
            </div>

            <div className={style.copyright}>
                <p>&copy; {currentYear} Dentisan Clinica Dental. Todos los derechos reservados.</p>
            </div>
        </footer>
    );
}

export default Footer;
